import { useCallback, useEffect, useState } from "react";
import api from "../../../../Component/axios";
import axios from "axios";
import Swal from "sweetalert2";

export const useCultivo = () => {
  const token = localStorage.getItem("@Token");
  const [cultivo, setCultivo] = useState([]);

  const getCultivo = useCallback(async () => {
    try {
      const response = await api.get("api/cultivo/cultivo/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + token,
        },
      });
      setCultivo(response.data);
    } catch (error) {
      console.error(error);
    }
  }, [token]);

  const saveCultivo = async (cultivo, envases) => {
    try {
      await api.post(
        "api/cultivo/cultivo/",
        { cultivo, envases },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + token,
          },
        }
      );
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response.status === 400) {
          Swal.fire({ icon: "error", title: error.response.data.msg });
          throw error;
        }
      }
      Swal.fire({
        icon: "error",
        title: "Algo saló mal",
        text: "Favor de comunicarlo con el equipo de desarrollo",
      });
      console.error(error);
      throw error;
    }
  };

  const deleteCultivo = async (id_cultivo, estatus) => {
    try {
      await api.put(
        "api/cultivo/cultivo/",
        { id_cultivo, estatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + token,
          },
        }
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const retriveCultivo = useCallback(
    async (id_cultivo) => {
      try {
        const response = await api.get(
          `api/cultivo/cultivo/?id_cultivo=${id_cultivo}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Token " + token,
            },
          }
        );
        console.log(response.data);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    [token]
  );

  const editarCultivo = async (id_cultivo, envases, cultivo) => {
    try {
      await api.put(
        "api/cultivo/cultivo/",
        { id_cultivo, envases, cultivo },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + token,
          },
        }
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  useEffect(() => {
    getCultivo();
  }, [token, getCultivo]);

  return {
    cultivo,
    saveCultivo,
    deleteCultivo,
    getCultivo,
    retriveCultivo,
    editarCultivo,
  };
};
